import React from "react";
import BotCard from "./BotCard";

function YourBotArmy({ army, removeBot, dischargeBot }) {
  return (
    <div>
      <h2>Your Bot Army</h2>
      <div className="your-bot-army">
        {army.map((bot) => (
          <BotCard
            key={bot.id}
            bot={bot}
            handleClick={removeBot}
            dischargeBot={dischargeBot}
            inArmy
          />
        ))}
      </div>
    </div>
  );
}

export default YourBotArmy;
